export default "__VITE_ASSET__dceec4de__"